export const constructFullName = (firstName?: string | null, lastName?: string | null) => {
  if (firstName && lastName) return `${firstName} ${lastName}`
  return firstName || lastName || null
}
